import React, { useState, useContext, useEffect } from "react";
import {
  makeStyles,
  Card,
  Grid,
  TextField,
  Button,
  // InputAdornment,
  // IconButton,
  CircularProgress,
  Tooltip,
} from "@material-ui/core";

// import { MdVisibility, MdVisibilityOff } from "react-icons/md";
import useReactRouter from "use-react-router";
import { LangContext } from "../../../Context/Langcontext";
import { UserContext } from "../../../Context/UserContext";
import { useCallback } from "react";
import { updateUser } from "../../../API/User";
import { useSnackbar } from "notistack";
import ChangePassword from "./changePassword";
import { getChangePassword } from "../../../API/Auth";

const useStyle = makeStyles((theme) => ({
  root: {
    width: "98%",
    height: "99.5%",
  },
  card: {
    width: "100%",
    height: "10rem",
    backgroundColor: "#FFFFFF",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    boxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    WebkitBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    MozBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    borderRadius: 8,
  },
  cardapi: {
    width: "100%",
    // height: "auto",
    backgroundColor: "#FFFFFF",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    flexDirection: "column",
    boxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    WebkitBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    MozBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    borderRadius: 8,
    minHeight: "100%",
    maxHeight: "auto",
  },
  btnstyle: {
    borderRadius: 8,
    padding: "0.4rem 2rem",
    fontSize: "1rem",
    fontWeight: 200,
    textTransform: "unset",
    backgroundColor: "#E16733",
    color: "#FFFFFF",
    "&:hover": {
      background: "#e16733",
      boxShadow: `0px 0px 20px -1px #a8a8a8`,
      transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    },
  },
  btndis: {
    borderRadius: 8,
    padding: "0.4rem 2rem",
    fontSize: "1rem",
    fontWeight: 200,
    textTransform: "unset",
    backgroundColor: "#ebebeb",
    color: "#FFFFFF",
  },
  textfield: {
    "& .MuiInputBase-input": {
      fontWeight: 200,
    },
  },
  label: { fontWeight: 400 },
}));

const UserInfo = ({ choice }) => {
  const classes = useStyle();
  const { location } = useReactRouter();
  const langContext = useContext(LangContext);
  const userContext = useContext(UserContext);
  const user = userContext.state;
  const lang = langContext.lang.data;
  const [disable, setDisable] = useState(true);
  const [billdis, setbillDis] = useState(true);
  const [changedis, setchangeDis] = useState(true);
  const [loading, setloading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [fetch, setFetch] = useState(false);
  // const [fetch, setfetch] = useState(false);

  const [form, setForm] = useState([
    {
      name: "name",
      title: lang.Name,
      value: user.first_name,
      secure: false,
    },
    {
      name: "lastname",
      title: lang.Lastname,
      value: user.last_name,
      secure: false,
    },
    {
      name: "phone",
      title: lang.Phone,
      value: user.phone,
      secure: false,
    },
    {
      name: "organization",
      title: lang.Organization,
      value: user.organization,
      secure: false,
    },
    {
      name: "address",
      title: lang.Address,
      value: user.address,
      secure: false,
    },
    {
      name: "district",
      title: lang.District,
      value: user.amphoe,
      secure: false,
    },
    {
      name: "subdistrict",
      title: lang.Subdistrict,
      value: user.tambon,
      secure: false,
    },
    {
      name: "city",
      title: lang.City,
      value: user.province,
      secure: false,
    },
    {
      name: "country",
      title: lang.Country,
      value: user.country,
      secure: false,
    },
    {
      name: "zipcode",
      title: lang.Zipcode,
      value: user.zipcode,
      secure: false,
    },
  ]);

  const [billing, setBilling] = useState([
    {
      name: "billing_name",
      title: lang.Name,
      value: user.billing_info.first_name,
      secure: false,
    },
    {
      name: "billing_lastname",
      title: lang.Lastname,
      value: user.billing_info.last_name,
      secure: false,
    },
    {
      name: "billing_phone",
      title: lang.Phone,
      value: user.billing_info.phone,
      secure: false,
    },
    {
      name: "billing_organization",
      title: lang.Organization,
      value: user.billing_info.organization,
      secure: false,
    },
    {
      name: "billing_address",
      title: lang.Address,
      value: user.billing_info.address,
      secure: false,
    },
    {
      name: "billing_district",
      title: lang.District,
      value: user.billing_info.amphoe,
      secure: false,
    },
    {
      name: "billing_subdistrict",
      title: lang.Subdistrict,
      value: user.billing_info.tambon,
      secure: false,
    },
    {
      name: "billing_city",
      title: lang.City,
      value: user.billing_info.province,
      secure: false,
    },
    {
      name: "billing_country",
      title: lang.Country,
      value: user.billing_info.country,
      secure: false,
    },
    {
      name: "billing_zipcode",
      title: lang.Zipcode,
      value: user.billing_info.zipcode,
      secure: false,
    },
    {
      name: "tax",
      title: lang.Tax,
      value: user.billing_info.tax,
      secure: false,
    },
  ]);

  const [state, setstate] = useState({ oldpassword: "", newpassword: "" });
  const onChangeText = (e, index) => {
    const formvalue = [...form];
    formvalue[index].value = e.target.value;
    setForm(formvalue);
    if (formvalue[index].value !== e.target.value) {
      setDisable(true);
    } else {
      setDisable(false);
    }
  };

  const onChangeBill = (e, index) => {
    const formvalue = [...billing];
    formvalue[index].value = e.target.value;
    setBilling(formvalue);
    if (formvalue[index].value !== e.target.value) {
      setbillDis(true);
    } else {
      setbillDis(false);
    }
  };

  const setData = useCallback(() => {
    setForm([
      {
        name: "name",
        title: lang.Name,
        value: user.first_name,
        secure: false,
      },
      {
        name: "lastname",
        title: lang.Lastname,
        value: user.last_name,
        secure: false,
      },
      {
        name: "phone",
        title: lang.Phone,
        value: user.phone,
        secure: false,
      },
      {
        name: "organization",
        title: lang.Organization,
        value: user.organization,
        secure: false,
      },
      {
        name: "address",
        title: lang.Address,
        value: user.address,
        secure: true,
      },
      {
        name: "district",
        title: lang.District,
        value: user.amphoe,
        secure: false,
      },
      {
        name: "subdistrict",
        title: lang.Subdistrict,
        value: user.tambon,
        secure: false,
      },
      {
        name: "city",
        title: lang.City,
        value: user.province,
        secure: false,
      },
      {
        name: "country",
        title: lang.Country,
        value: user.country,
        secure: false,
      },
      {
        name: "zipcode",
        title: lang.Zipcode,
        value: user.zipcode,
        secure: false,
      },
    ]);

    setBilling([
      {
        name: "billing_name",
        title: lang.Name,
        value: user.billing_info.first_name,
        secure: false,
      },
      {
        name: "billing_lastname",
        title: lang.Lastname,
        value: user.billing_info.last_name,
        secure: false,
      },
      {
        name: "billing_phone",
        title: lang.Phone,
        value: user.billing_info.phone,
        secure: false,
      },
      {
        name: "billing_organization",
        title: lang.Organization,
        value: user.billing_info.organization,
        secure: false,
      },
      {
        name: "billing_address",
        title: lang.Address,
        value: user.billing_info.address,
        secure: false,
      },
      {
        name: "billing_district",
        title: lang.District,
        value: user.billing_info.amphoe,
        secure: false,
      },
      {
        name: "billing_subdistrict",
        title: lang.Subdistrict,
        value: user.billing_info.tambon,
        secure: false,
      },
      {
        name: "billing_city",
        title: lang.City,
        value: user.billing_info.province,
        secure: false,
      },
      {
        name: "billing_country",
        title: lang.Country,
        value: user.billing_info.country,
        secure: false,
      },
      {
        name: "billing_zipcode",
        title: lang.Zipcode,
        value: user.billing_info.zipcode,
        secure: false,
      },
      {
        name: "tax",
        title: lang.Tax,
        value: user.billing_info.tax,
        secure: false,
      },
    ]);
  }, [user, lang]);

  useEffect(() => {
    if (!fetch && userContext.state._id !== "") {
      setData();
      setFetch(true);
    } else {
    }
  }, [fetch, setData, userContext]);

  const update = async () => {
    let input = {
      first_name: form[0].value,
      last_name: form[1].value,
      organization: form[3].value,
      address: form[4].value,
      tambon: form[6].value,
      amphoe: form[5].value,
      province: form[7].value,
      zipcode: form[9].value,
      country: form[8].value,
      phone: form[2].value,
      billing_info: user.billing_info !== undefined ? user.billing_info : null,
      role: user.role,
      enabled: true,
    };

    const updateuser = await updateUser(user._id, input);
    if (updateuser.status.code === 200) {
      input.email = user.email;
      input.created_at = user.created_at;
      input._id = user._id;
      input.profile_picture =
        user.profile_picture !== undefined ? user.profile_picture : "";
      input.google = user.google;
      input.facebook = user.facebook;
      input.mea = user.mea;
      setloading(true);
      setTimeout(() => {
        setloading(false);
        userContext.setstate(input);
        enqueueSnackbar(lang.Updateusersuccess, {
          variant: "success",
        });
      }, 2000);
    } else {
      enqueueSnackbar(updateuser.status.message, {
        variant: "error",
      });
    }

    setDisable(true);
  };

  const updatebill = async () => {
    let input = {
      first_name: user.first_name,
      last_name: user.last_name,
      organization: user.organization,
      address: user.address,
      tambon: user.tambon,
      amphoe: user.amphoe,
      province: user.province,
      zipcode: user.zipcode,
      country: user.country,
      phone: user.phone,
      billing_info: {
        first_name: billing[0].value,
        last_name: billing[1].value,
        organization: billing[3].value,
        address: billing[4].value,
        tambon: billing[6].value,
        amphoe: billing[5].value,
        province: billing[7].value,
        zipcode: billing[9].value,
        country: billing[8].value,
        phone: billing[2].value,
        tax: billing[10].value,
      },
      role: user.role,
      enabled: true,
    };
    const updateuser = await updateUser(user._id, input);
    if (updateuser.status.code === 200) {
      input.email = user.email;
      input.created_at = user.created_at;
      input._id = user._id;
      input.profile_picture =
        user.profile_picture !== undefined ? user.profile_picture : "";
      input.google = user.google;
      input.facebook = user.facebook;
      input.mea = user.mea;
      setloading(true);
      setTimeout(() => {
        setloading(false);
        userContext.setstate(input);
        enqueueSnackbar("Update bill completed", {
          variant: "success",
        });
      }, 2000);
    } else {
      enqueueSnackbar(updateuser.status.message, {
        variant: "error",
      });
    }

    setbillDis(true);
  };

  const updatepassword = async () => {
    let input = {
      old_password: state.oldpassword,
      new_password: state.newpassword,
    };
    const updatepass = await getChangePassword(input);
    if (updatepass.status.code === 200) {
      setstate({ ...state, newpassword: "", oldpassword: "" });
      setloading(true);
      setTimeout(() => {
        setloading(false);
        enqueueSnackbar("Update password completed", {
          variant: "success",
        });
      }, 2000);
    } else {
      enqueueSnackbar(updatepass.status.message, {
        variant: "error",
      });
    }

    setchangeDis(true);
  };
  return (
    <div className={classes.root}>
      <Card className={classes.cardapi}>
        <div style={{ margin: "4rem", width: "-webkit-fill-available" }}>
          <Grid container spacing={6}>
            {location.pathname === "/app/user/main" ? (
              form.map((item, index) => {
                return localStorage.getItem("role") === "admin" ||
                  localStorage.getItem("role") === "root" ? (
                  item.secure ? null : (
                    <Grid item xs={6} key={`key_${item.title}`}>
                      <TextField
                        id={`text_${item.name}`}
                        label={item.title}
                        name={item.name}
                        fullWidth
                        className={classes.textfield}
                        value={item.value}
                        onChange={(e) => {
                          onChangeText(e, index);
                        }}
                        InputLabelProps={{
                          className: classes.label,
                        }}
                      />
                    </Grid>
                  )
                ) : (
                  <Grid item xs={6} key={`key2_${item.title}`}>
                    <TextField
                      id={`text1_${item.name}`}
                      label={item.title}
                      name={item.name}
                      fullWidth
                      className={classes.textfield}
                      value={item.value}
                      onChange={(e) => {
                        onChangeText(e, index);
                      }}
                      InputLabelProps={{
                        className: classes.label,
                      }}
                    />
                  </Grid>
                );
              })
            ) : location.pathname === "/app/user/billing" ? (
              billing.map((item, index) => {
                return (
                  <Grid item xs={6} key={`key3_${item.title}`}>
                    <TextField
                      id={`text2_${item.name}`}
                      label={item.title}
                      name={item.name}
                      fullWidth
                      className={classes.textfield}
                      InputLabelProps={{
                        className: classes.label,
                      }}
                      value={item.value}
                      onChange={(e) => {
                        onChangeBill(e, index);
                      }}
                    />
                  </Grid>
                );
              })
            ) : (
              <ChangePassword
                setchangeDis={setchangeDis}
                state={state}
                setstate={setstate}
              />
            )}

            <Grid
              item
              xs={12}
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "flex-end",
              }}
            >
              <Tooltip title="ตรวจสอบให้แน่ใจก่อนทำการบันทึก" placement="top">
                <span>
                  <Button
                    disabled={
                      location.pathname === "/app/user/main"
                        ? disable
                        : location.pathname === "/app/user/billing"
                        ? billdis
                        : changedis
                    }
                    className={
                      location.pathname === "/app/user/main"
                        ? disable
                          ? classes.btndis
                          : classes.btnstyle
                        : location.pathname === "/app/user/billing"
                        ? billdis
                          ? classes.btndis
                          : classes.btnstyle
                        : changedis
                        ? classes.btndis
                        : classes.btnstyle
                    }
                    onClick={
                      location.pathname === "/app/user/main"
                        ? update
                        : location.pathname === "/app/user/billing"
                        ? updatebill
                        : updatepassword
                    }
                    startIcon={
                      loading ? (
                        <CircularProgress
                          size={24}
                          style={{ marginRight: "0.5rem", color: "#b0b0b0" }}
                        />
                      ) : null
                    }
                  >
                    {loading ? lang.onSave : lang.SaveChange}
                  </Button>
                </span>
              </Tooltip>
            </Grid>
          </Grid>
        </div>
      </Card>
    </div>
  );
};

export default UserInfo;
